import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'undertakingService'
var path = '/Undertaking/'
var isDebug = false

function put (http, undertaking) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, undertaking)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?undertakingId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search')

    return http.post(path + 'Search', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function searchByTrs (http, searchList) {
    loggingService.log(isDebug, serviceName, 'searchTrs')

    return http.post(path + 'SearchByTrs', searchList).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function todo (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'todo')

    return http.post(path + 'Todo', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function searchUnassigned (http, searchObj) {
    loggingService.log(isDebug, serviceName, 'searchUnassigned')

    return http.post(path + 'SearchUnassigned', searchObj).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function searchInProgress (http, searchObj) {
    loggingService.log(isDebug, serviceName, 'searchInProgress')

    return http.post(path + 'SearchInProgress', searchObj).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function setMoa (http, setMoaDto) {
    loggingService.log(isDebug, serviceName, 'setMoa')
    return http.put(path + 'SetMoa', setMoaDto)
}

function setPa (http, setPaDto) {
    loggingService.log(isDebug, serviceName, 'setPa')
    return http.put(path + 'SetPa', setPaDto)
}

function setCulturalResource (http, setCulturalResourceDto) {
    loggingService.log(isDebug, serviceName, 'setCulturalResource')
    return http.put(path + 'SetCulturalResource', setCulturalResourceDto)
}

function deleteCulturalResource (http, undertakingCulturalResourceId) {
    loggingService.log(isDebug, serviceName, 'deleteCulturalResource, undertakingCulturalResourceId: ' + undertakingCulturalResourceId)
    return http.delete(path + 'DeleteCulturalResource?undertakingCulturalResourceId=' + undertakingCulturalResourceId)
}

function listCulturalResources (http, id) {
    loggingService.log(isDebug, serviceName, 'listCulturalResources')
    return http.get(path + 'ListCulturalResources?undertakingId=' + id)
}

function undertakingReportGen (http, undId) {
    return http.get(path + `UndertakingReportGen?undertakingId=${undId}`, { responseType: 'arraybuffer' })
}

function putPlss (http, undertakingId, plss) {
    loggingService.log(isDebug, serviceName, 'putPlss - undertakingId: ' + undertakingId + ', plss: ' + plss)

    var data = {
        parentId: undertakingId,
        parentType: 'Undertaking',
        plssLocation: plss,
        sections: plss.Sections
    }

    return http.put(path + 'PutPlss', data)
}

function listUndertakingPlssLocationResultDto (http, undertakingId) {
    loggingService.log(isDebug, serviceName, 'listUndertakingPlssLocationResultDto')

    return http.get(path + 'ListUndertakingPlssLocationResultDto?undertakingId=' + undertakingId).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })
        return response
    })
}

function deletePlssLocation (http, undertakingPlssLocationId) {
    loggingService.log(isDebug, serviceName, 'deletePlssLocation, undertakingPlssLocationId: ' + undertakingPlssLocationId)
    return http.delete(path + 'deletePlss?undertakingPlssLocationId=' + undertakingPlssLocationId)
}

const ReviewFrameworkList = [
    { id: 1, description: 'State Protocol', type: 'blm' },
    { id: 2, description: 'USFS Programmatic Agreement', type: 'usfs' },
    { id: 3, description: 'NRCS Programmatic Agreement', type: 'nrcs' },
    { id: 99, description: 'Standard S106', type: 'none' }
]

const InventoryTypeList = [
    { id: 1, description: 'New' },
    { id: 2, description: 'Previous Adequate Inventory' },
    { id: 3, description: 'Mixed' },
    { id: 4, description: 'Other' }
]

export default {
    put: put,
    get: get,
    search: search,
    searchByTrs: searchByTrs,
    todo: todo,
    searchUnassigned: searchUnassigned,
    searchInProgress: searchInProgress,
    setMoa: setMoa,
    setPa: setPa,
    setCulturalResource: setCulturalResource,
    deleteCulturalResource: deleteCulturalResource,
    listCulturalResources: listCulturalResources,
    undertakingReportGen: undertakingReportGen,
    putPlss: putPlss,
    listUndertakingPlssLocationResultDto: listUndertakingPlssLocationResultDto,
    deletePlssLocation: deletePlssLocation,
    ReviewFrameworkList: ReviewFrameworkList,
    InventoryTypeList: InventoryTypeList
}



// WEBPACK FOOTER //
// ./src/services/undertakingService.js